<div class="panel-heading"
     style="background-color:#344C67; color:#ffffff; border-top-left-radius: 0; border-top-right-radius: 0"
     id="expandCollapse">
  <div style="display: flex; justify-content: space-between">
    <div>
      <h4 style="display:inline-block; margin:8px 10px 6px 0;">Additional Site Information</h4>
      <app-help-docs-links recordType="info view"></app-help-docs-links>
    </div>
    <div>
      <ng-content></ng-content>
    </div>
    <!--      <button type="button" class="btn btn-primary pull-right" (click)="expandCollapse.emit(false)"-->
    <!--              *ngIf="!(expandCollapse | async)">-->
    <!--        <i class="fa fa-chevron-up"></i> Collapse All-->
    <!--      </button>-->
    <!--      <button type="button" class="btn btn-primary pull-right" (click)="expandCollapse.emit(true)"-->
    <!--              *ngIf="expandCollapse | async">-->
    <!--        <i class="fa fa-chevron-down"></i> Expand All-->
    <!--      </button>-->
  </div>
</div>

